import App from "@bloglovin/inspire-engine/App";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { readBoundContextName, resolveBoundEntityId } from "%/dynamic-component-editor/helpers/bound-context-entity-id";

const EPISODE_ENTITY_TYPE = "Episode";

const EMPTY_EPISODE_ENTITY = Object.freeze({
  id: 0,
  title: "",
  summary: "",
  coverImage: "",
  episodeNumber: 0,
  duration: 0,
  releasedAt: 0,
  season: null,
  show: null,
  showId: 0,
  seasonId: 0,
  seasonNumber: 0,
  storyId: 0,
  author: "",
  spotifyUrl: "",
  applePodcastsUrl: "",
  youtubeUrl: "",
  pocketcastsUrl: "",
  likeCount: 0,
  commentCount: 0,
  shareCount: 0,
  voteScore: 0,
  upvoteCount: 0,
  downvoteCount: 0,
});

export const BaseEpisodeCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
    scopedProvidedContexts: { default: null },
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    boundContextName() {
      return readBoundContextName(this);
    },
    episodeEntityId() {
      return resolveBoundEntityId(this, "episode");
    },
    hasResolvedEpisodeEntity() {
      const id = this.episodeEntityId;
      if (!id) {
        return false;
      }
      const entity = App.get(contextualAppName()).getEntity(EPISODE_ENTITY_TYPE, { id });
      return Boolean(entity && entity.isHydrated);
    },
    hideUntilEpisodeEntityResolved() {
      return !this.editMode && !this.isPreviewMode && !this.hasResolvedEpisodeEntity;
    },
  },
  methods: {
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.$options.exampleEntity ?? EMPTY_EPISODE_ENTITY;
      }
      const id = this.episodeEntityId;
      if (!id) {
        return EMPTY_EPISODE_ENTITY;
      }
      const entity = App.get(contextualAppName()).getEntity(EPISODE_ENTITY_TYPE, { id });
      return entity || EMPTY_EPISODE_ENTITY;
    },
  },
  exampleEntity: {
    id: 1,
    title: "Demo Episode",
    summary: "A demo episode summary.",
    coverImage: "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fashion-story-sample-image.webp",
    episodeNumber: 1,
    duration: 300,
    releasedAt: 1733412192,
    season: { id: 1 },
    show: { id: 1 },
    showId: 1,
    seasonId: 1,
    seasonNumber: 1,
    storyId: 0,
    author: "John Smith",
    spotifyUrl: "",
    applePodcastsUrl: "",
    youtubeUrl: "",
    pocketcastsUrl: "",
    likeCount: 0,
    commentCount: 0,
    shareCount: 0,
    voteScore: 0,
    upvoteCount: 0,
    downvoteCount: 0,
  },
};
